import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RestService from '../Services/RestService';
import OKomLoading from '../Components/OsloKommuneUI/OKomLoading';
import PktAlert from '../Components/PktAlert';
import { useUserContext } from '../Components/StateContext/UserContext';

const MAX_CHILDREN = 5;

const DOB_REGEX = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(\d{4})$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NO_MOBILE_REGEX = /^[49]\d{7}$/;

type Lang = 'no' | 'ta';

interface Strings {
  toggleNo: string;
  toggleTa: string;
  loading: string;
  childHeading: (n: number, total: number) => string;
  parentHeading: string;
  parent2Heading: string;
  firstname: string;
  lastname: string;
  firstnameTamil: string;
  lastnameTamil: string;
  dateOfBirth: string;
  department: string;
  className: string;
  selectDepartment: string;
  selectClass: string;
  classLabel: (n: number) => string;
  parentEmail: string;
  parentMobile: string;
  addChild: string;
  addParent: string;
  removeChildAria: (n: number) => string;
  removeParent2Aria: string;
  send: string;
  validationTitle: string;
  loginLink: string;
  childLabel: (n: number, total: number) => string;
  validation: {
    minOneChild: string;
    firstnameRequired: (label: string) => string;
    lastnameRequired: (label: string) => string;
    firstnameTamilRequired: (label: string) => string;
    lastnameTamilRequired: (label: string) => string;
    dobRequired: (label: string) => string;
    dobFormat: (label: string) => string;
    dobInvalid: (label: string) => string;
    departmentRequired: (label: string) => string;
    classRequired: (label: string) => string;
    parentEmailRequired: string;
    parentEmailInvalid: string;
    parentMobileRequired: string;
    parentMobileFormat: string;
    parent2EmailRequired: string;
    parent2EmailInvalid: string;
    parent2MobileRequired: string;
    parent2MobileFormat: string;
  };
  loadDepartmentsFailed: string;
  somethingWrong: string;
  successHeading: string;
  successLead: string;
  summaryHeading: string;
  summaryChildren: string;
  summaryParents: string;
  born: string;
  emailNotice: string;
  signoff: string;
  orgName: string;
  practicalHeading: string;
  practicalAddressLabel: string;
  practicalContactLabel: string;
  colFirstname: string;
  colLastname: string;
  colTamilName: string;
  colDob: string;
  colEmail: string;
  colMobile: string;
  privacyLink: string;
}

const stringsNo: Strings = {
  toggleNo: 'Norsk',
  toggleTa: 'தமிழ்',
  loading: 'Lagrer, vennligst vent...',
  childHeading: (n, total) => total > 1 ? `OM ELEV ${n}` : 'OM ELEVEN',
  parentHeading: 'OM FORELDER',
  parent2Heading: 'OM FORELDER 2',
  firstname: 'Fornavn',
  lastname: 'Etternavn',
  firstnameTamil: 'Fornavn (tamilsk)',
  lastnameTamil: 'Etternavn (tamilsk)',
  dateOfBirth: 'Fødselsdato (dd.mm.yyyy)',
  department: 'Avdeling',
  className: 'Klasse',
  selectDepartment: '-- velg avdeling --',
  selectClass: '-- velg klasse --',
  classLabel: (n) => `${n}.klasse`,
  parentEmail: 'Forelder e-post',
  parentMobile: 'Forelder mobilnummer',
  addChild: '+ Legg til elev',
  addParent: '+ Legg til forelder',
  removeChildAria: (n) => `Fjern elev ${n}`,
  removeParent2Aria: 'Fjern forelder 2',
  send: 'Send',
  validationTitle: 'Mangler informasjon',
  loginLink: 'Logg inn',
  childLabel: (n, total) => total > 1 ? `elev ${n}` : 'eleven',
  validation: {
    minOneChild: 'Minst en elev må registreres',
    firstnameRequired: (l) => `Fornavn er påkrevd for ${l}`,
    lastnameRequired: (l) => `Etternavn er påkrevd for ${l}`,
    firstnameTamilRequired: (l) => `Fornavn (tamilsk) er påkrevd for ${l}.`,
    lastnameTamilRequired: (l) => `Etternavn (tamilsk) er påkrevd for ${l}.!`,
    dobRequired: (l) => `Fødselsdato er påkrevd for ${l}`,
    dobFormat: (l) => `Fødselsdato må være på format dd.mm.yyyy for eksempel 25.03.2012 (${l})`,
    dobInvalid: (l) => `Fødselsdato finnes ikke (${l})`,
    departmentRequired: (l) => `Avdeling er påkrevd for ${l}`,
    classRequired: (l) => `Klasse er påkrevd for ${l}`,
    parentEmailRequired: 'Forelder e-post er påkrevd',
    parentEmailInvalid: 'Ugyldig e-postadresse',
    parentMobileRequired: 'Forelder mobilnummer er påkrevd',
    parentMobileFormat: 'Mobilnummer må være 8 siffer og starte med 4 eller 9 (uten +47)',
    parent2EmailRequired: 'Forelder 2 e-post er påkrevd',
    parent2EmailInvalid: 'Ugyldig e-postadresse for forelder 2',
    parent2MobileRequired: 'Forelder 2 mobilnummer er påkrevd',
    parent2MobileFormat: 'Mobilnummer for forelder 2 må være 8 siffer og starte med 4 eller 9 (uten +47)',
  },
  loadDepartmentsFailed: 'Kunne ikke laste avdelinger',
  somethingWrong: 'Noe gikk galt',
  successHeading: 'TAKK FOR PÅMELDINGEN',
  successLead: 'Vi har registrert påmeldingen din.',
  summaryHeading: 'Oppsummering av registrering:',
  summaryChildren: 'Elever:',
  summaryParents: 'Foreldre:',
  born: 'f.',
  emailNotice: 'Du vil også få en bekreftelse på epost.',
  signoff: 'Med vennlig hilsen',
  orgName: 'Annaipoopathi aktivitets- og kultursenter (APTAK)',
  practicalHeading: 'PRAKTISKE OPPLYSNINGER',
  practicalAddressLabel: 'Adresse',
  practicalContactLabel: 'Kontakt',
  colFirstname: 'Fornavn',
  colLastname: 'Etternavn',
  colTamilName: 'Tamilsk navn',
  colDob: 'Fødselsdato',
  colEmail: 'E-post',
  colMobile: 'Mobilnummer',
  privacyLink: 'Personvernvilkår',
};

const stringsTa: Strings = {
  toggleNo: 'Norsk',
  toggleTa: 'தமிழ்',
  loading: 'சேமிக்கப்படுகிறது, காத்திருக்கவும்...',
  childHeading: (n, total) => total > 1 ? `மாணவர் ${n} விவரம்` : 'மாணவர் விவரம்',
  parentHeading: 'பெற்றோர் விவரம்',
  parent2Heading: 'பெற்றோர் 2 விவரம்',
  firstname: 'பெயர் (நோர்வேயியமொழியில்)',
  lastname: 'குடும்பப்பெயர் (நோர்வேயியமொழியில்)',
  firstnameTamil: 'பெயர் (தமிழில்)',
  lastnameTamil: 'குடும்பப்பெயர் (தமிழில்)',
  dateOfBirth: 'பிறந்த திகதி',
  department: 'வளாகம்',
  className: 'கல்வி கற்கும் ஆண்டு',
  selectDepartment: '-- வளாகத்தைத் தேர்வு செய்யவும் --',
  selectClass: '-- கல்வி கற்கும் ஆண்டைத் தேர்வு செய்யவும் --',
  classLabel: (n) => `${n}ஆம் ஆண்டு`,
  parentEmail: 'மின்னஞ்சல் முகவரி',
  parentMobile: 'தொலைபேசி இலக்கம்',
  addChild: '+ மாணவரை இணைக்கவும்',
  addParent: '+ பெற்றோரை இணைக்கவும்',
  removeChildAria: (n) => `மாணவர் ${n} ஐ அகற்று`,
  removeParent2Aria: 'பெற்றோர் 2 ஐ அகற்று',
  send: 'அனுப்பவும்',
  validationTitle: 'தகவல் இல்லை',
  loginLink: 'உள்நுழைய',
  childLabel: (n, total) => total > 1 ? `மாணவர் ${n}` : 'மாணவர்',
  validation: {
    minOneChild: 'குறைந்தது ஒரு மாணவரைப் பதிவு செய்ய வேண்டும்',
    firstnameRequired: (l) => `${l}க்கு பெயர் தேவை`,
    lastnameRequired: (l) => `${l}க்கு குடும்பப்பெயர் தேவை`,
    firstnameTamilRequired: (l) => `${l}க்கு பெயர் (தமிழில்) தேவை`,
    lastnameTamilRequired: (l) => `${l}க்கு குடும்பப்பெயர் (தமிழில்) தேவை`,
    dobRequired: (l) => `${l}க்கு பிறந்த திகதி தேவை`,
    dobFormat: (l) => `பிறந்த திகதி dd.mm.yyyy வடிவில் இருக்க வேண்டும், எடுத்துக்காட்டாக 25.03.2012 (${l})`,
    dobInvalid: (l) => `பிறந்த திகதி தவறானது (${l})`,
    departmentRequired: (l) => `${l}க்கு வளாகம் தேவை`,
    classRequired: (l) => `${l}க்கு கல்வி கற்கும் ஆண்டு தேவை`,
    parentEmailRequired: 'மின்னஞ்சல் முகவரி தேவை',
    parentEmailInvalid: 'தவறான மின்னஞ்சல் முகவரி',
    parentMobileRequired: 'தொலைபேசி இலக்கம் தேவை',
    parentMobileFormat: 'தொலைபேசி இலக்கம் 8 இலக்கங்களாக இருக்க வேண்டும், 4 அல்லது 9 இல் தொடங்க வேண்டும் (+47 இல்லாமல்)',
    parent2EmailRequired: 'பெற்றோர் 2 இன் மின்னஞ்சல் முகவரி தேவை',
    parent2EmailInvalid: 'பெற்றோர் 2 க்கு தவறான மின்னஞ்சல் முகவரி',
    parent2MobileRequired: 'பெற்றோர் 2 இன் தொலைபேசி இலக்கம் தேவை',
    parent2MobileFormat: 'பெற்றோர் 2 இன் தொலைபேசி இலக்கம் 8 இலக்கங்களாக இருக்க வேண்டும், 4 அல்லது 9 இல் தொடங்க வேண்டும் (+47 இல்லாமல்)',
  },
  loadDepartmentsFailed: 'வளாகங்களை ஏற்ற முடியவில்லை',
  somethingWrong: 'ஏதோ தவறு நடந்தது',
  successHeading: 'பதிவுக்கு நன்றி',
  successLead: 'உங்கள் பதிவு பெறப்பட்டது.',
  summaryHeading: 'பதிவின் சுருக்கம்:',
  summaryChildren: 'குழந்தைகள்:',
  summaryParents: 'பெற்றோர்கள்:',
  born: 'பிறந்த திகதி:',
  emailNotice: 'உங்களுக்கு மின்னஞ்சலில் உறுதிப்படுத்தல் வரும்.',
  signoff: 'அன்பான வாழ்த்துகள்',
  orgName: 'Annaipoopathi aktivitets- og kultursenter (APTAK)',
  practicalHeading: 'நடைமுறை விவரங்கள்',
  practicalAddressLabel: 'முகவரி',
  practicalContactLabel: 'தொடர்புக்கு',
  colFirstname: 'பெயர்',
  colLastname: 'குடும்பப்பெயர்',
  colTamilName: 'தமிழ் பெயர்',
  colDob: 'பிறந்த திகதி',
  colEmail: 'மின்னஞ்சல்',
  colMobile: 'தொலைபேசி',
  privacyLink: 'தனிநபர் பாதுகாப்பு',
};

const STRINGS: Record<Lang, Strings> = { no: stringsNo, ta: stringsTa };

const ALLOWED_DEPARTMENT_IDS = new Set<number>([1, 9, 10, 11, 13]);

const PRACTICAL_INFO = {
  addressLines: ['Groruddalen skole', 'Vestbyveien 13', '0976 Oslo'],
  contactEmail: 'exam@annaipoopathi.no',
  contactPhone: '+47 972 97 778',
};
const MAPS_URL = `https://www.google.com/maps?q=${encodeURIComponent(PRACTICAL_INFO.addressLines.join(', '))}`;

interface ExamEvent {
  name: Record<Lang, string>;
  date: Record<Lang, string>;
}

const EXAM_EVENTS: ExamEvent[] = [
  {
    name: {
      no: 'Skriftlig hovedeksamen',
      ta: 'அனைத்துலகப் பொதுத்தேர்வு (எழுத்துத் தேர்வு)',
    },
    date: {
      no: 'lørdag 06.06.2026 kl. 09:30',
      ta: 'சனிக்கிழமை 06.06.2026 காலை 09:30',
    },
  },
  {
    name: {
      no: 'Muntlig eksamen (lytting, tale, lesing)',
      ta: 'புலன்மொழி வளத்தேர்வு (கேட்டல், பேசுதல், வாசித்தல்)',
    },
    date: {
      no: 'lørdag 16.05.2026 kl. 09:30',
      ta: 'சனிக்கிழமை 16.05.2026 காலை 09:30',
    },
  },
];

const emptyChild = (): Api.ExamRegistrationChild => ({
  Firstname: '',
  Lastname: '',
  FirstnameTamil: '',
  LastnameTamil: '',
  DateOfBirth: '',
  DepartmentId: 0,
  ClassName: '',
});

const emptyForm = (): Api.ExamRegistrationRequest => ({
  Children: [emptyChild()],
  ParentEmail: '',
  ParentMobile: '',
  Parent2Email: '',
  Parent2Mobile: '',
});

const summaryTableStyle: React.CSSProperties = {
  borderCollapse: 'collapse',
  fontSize: '0.875rem',
  width: '100%',
  marginTop: '0.5rem',
};
const summaryThStyle: React.CSSProperties = {
  border: '1px solid #ccc',
  padding: '6px 10px',
  background: '#f0f0f0',
  textAlign: 'left',
};
const summaryTdStyle: React.CSSProperties = {
  border: '1px solid #ccc',
  padding: '6px 10px',
};

const removeButtonStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '1.5rem',
  lineHeight: 1,
  padding: '0 .25rem',
};

const formatDob = (iso?: string): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}.${mm}.${d.getFullYear()}`;
};

const LanguageToggle: React.FC<{ language: Lang; setLanguage: (l: Lang) => void; t: Strings }> = ({ language, setLanguage, t }) => (
  <div className="ods-grid__column--12 ods-text--align-center">
    <div role="group" aria-label="Language" style={{ display: 'inline-flex', gap: '.5rem' }}>
      <button
        type="button"
        onClick={() => setLanguage('no')}
        className={language === 'no' ? 'ods-button' : 'ods-button ods-button--outline'}
      >{t.toggleNo}</button>
      <button
        type="button"
        onClick={() => setLanguage('ta')}
        className={language === 'ta' ? 'ods-button' : 'ods-button ods-button--outline'}
      >{t.toggleTa}</button>
    </div>
  </div>
);

const ExamRegistrationView: React.FC<RouteComponentProps> = () => {
  const { userToken } = useUserContext();
  const isAuthenticated = !!userToken;
  const [language, setLanguage] = useState<Lang>('no');
  const t = STRINGS[language];
  const classOptions = Array.from({ length: 12 }, (_, i) => ({ value: `${i + 1}.klasse`, label: t.classLabel(i + 1) }));

  const [isLoading, setIsLoading] = useState(false);
  const [departments, setDepartments] = useState<Api.Department[]>([]);
  const [form, setForm] = useState<Api.ExamRegistrationRequest>(emptyForm());
  const [validationError, setValidationError] = useState<string | null>(null);
  const [emailExistsFor, setEmailExistsFor] = useState<string | null>(null);
  const [showParent2, setShowParent2] = useState(false);
  const [submittedData, setSubmittedData] = useState<Api.ExamRegistrationRequest | null>(null);

  const validateChild = (child: Api.ExamRegistrationChild, label: string): string | null => {
    if (!child.Firstname.trim()) return t.validation.firstnameRequired(label);
    if (!child.Lastname.trim()) return t.validation.lastnameRequired(label);
    if (!child.FirstnameTamil?.trim()) return t.validation.firstnameTamilRequired(label);
    if (!child.LastnameTamil?.trim()) return t.validation.lastnameTamilRequired(label);
    if (!child.DateOfBirth?.trim()) return t.validation.dobRequired(label);
    if (!DOB_REGEX.test(child.DateOfBirth.trim())) return t.validation.dobFormat(label);
    const [day, month, year] = child.DateOfBirth.trim().split('.').map(Number);
    const dob = new Date(year, month - 1, day);
    if (dob.getFullYear() !== year || dob.getMonth() !== month - 1 || dob.getDate() !== day) return t.validation.dobInvalid(label);
    if (!child.DepartmentId || child.DepartmentId <= 0) return t.validation.departmentRequired(label);
    if (!child.ClassName) return t.validation.classRequired(label);
    return null;
  };

  const validateForm = (f: Api.ExamRegistrationRequest): string | null => {
    if (!f.Children || f.Children.length === 0) return t.validation.minOneChild;
    for (let i = 0; i < f.Children.length; i++) {
      const err = validateChild(f.Children[i], t.childLabel(i + 1, f.Children.length));
      if (err) return err;
    }
    if (!f.ParentEmail.trim()) return t.validation.parentEmailRequired;
    if (!EMAIL_REGEX.test(f.ParentEmail.trim())) return t.validation.parentEmailInvalid;
    if (!f.ParentMobile?.trim()) return t.validation.parentMobileRequired;
    if (!NO_MOBILE_REGEX.test(f.ParentMobile.trim())) return t.validation.parentMobileFormat;
    const hasParent2 = !!(f.Parent2Email?.trim() || f.Parent2Mobile?.trim());
    if (hasParent2) {
      if (!f.Parent2Email?.trim()) return t.validation.parent2EmailRequired;
      if (!EMAIL_REGEX.test(f.Parent2Email.trim())) return t.validation.parent2EmailInvalid;
      if (!f.Parent2Mobile?.trim()) return t.validation.parent2MobileRequired;
      if (!NO_MOBILE_REGEX.test(f.Parent2Mobile.trim())) return t.validation.parent2MobileFormat;
    }
    return null;
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await RestService.get<Api.Department[]>('/api/examregistration/GetDepartments');
        setDepartments(res);
      } catch (e) {
        toast.error(t.loadDepartmentsFailed);
      }
    })();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    (async () => {
      try {
        const rows = await RestService.get<Api.ExamRegistration[]>('/api/examregistration/MyRegistrations');
        if (rows && rows.length > 0) {
          const first = rows[0];
          setForm({
            Children: rows.map(r => ({
              Firstname: r.Firstname ?? '',
              Lastname: r.Lastname ?? '',
              FirstnameTamil: r.FirstnameTamil ?? '',
              LastnameTamil: r.LastnameTamil ?? '',
              DateOfBirth: formatDob(r.DateOfBirth),
              DepartmentId: r.DepartmentId ?? 0,
              ClassName: r.ClassName ?? '',
            })),
            ParentEmail: first.ParentEmail ?? '',
            ParentMobile: first.ParentMobile ?? '',
            Parent2Email: first.Parent2Email ?? '',
            Parent2Mobile: first.Parent2Mobile ?? '',
          });
          setShowParent2(!!first.Parent2Email);
        }
      } catch {
        // user has no existing registrations or fetch failed — silently leave form blank
      }
    })();
  }, [isAuthenticated]);

  const updateParent = <K extends keyof Api.ExamRegistrationRequest>(field: K, value: Api.ExamRegistrationRequest[K]) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setValidationError(null);
    setEmailExistsFor(null);
  };

  const updateChild = <K extends keyof Api.ExamRegistrationChild>(index: number, field: K, value: Api.ExamRegistrationChild[K]) => {
    setForm(prev => ({
      ...prev,
      Children: prev.Children.map((c, i) => (i === index ? { ...c, [field]: value } : c)),
    }));
    setValidationError(null);
    setEmailExistsFor(null);
  };

  const addChild = () => {
    setForm(prev => (prev.Children.length >= MAX_CHILDREN ? prev : { ...prev, Children: [...prev.Children, emptyChild()] }));
    setValidationError(null);
    setEmailExistsFor(null);
  };

  const removeChild = (index: number) => {
    setForm(prev => ({ ...prev, Children: prev.Children.filter((_, i) => i !== index) }));
    setValidationError(null);
    setEmailExistsFor(null);
  };

  const addParent2 = () => setShowParent2(true);
  const removeParent2 = () => {
    setShowParent2(false);
    setForm(prev => ({ ...prev, Parent2Email: '', Parent2Mobile: '' }));
    setValidationError(null);
    setEmailExistsFor(null);
  };

  const translateNameField = async (
    index: number,
    sourceField: 'Firstname' | 'Lastname',
    targetField: 'FirstnameTamil' | 'LastnameTamil',
  ) => {
    const child = form.Children[index];
    if (!child) return;
    const english = (child[sourceField] ?? '').trim();
    if (!english) return;
    if ((child[targetField] ?? '').trim()) return;
    try {
      const res = await RestService.post<Api.TranslateNameRequest, Api.TranslateNameResponse>(
        '/api/examregistration/TranslateName',
        { EnglishName: english },
      );
      if (res?.Tamil) {
        setForm(prev => ({
          ...prev,
          Children: prev.Children.map((c, i) =>
            i === index && !(c[targetField] ?? '').trim() ? { ...c, [targetField]: res.Tamil } : c,
          ),
        }));
      }
    } catch {
      // best-effort; user can type manually
    }
  };

  const handleSubmit = async () => {
    const error = validateForm(form);
    if (error) {
      setValidationError(error);
      setEmailExistsFor(null);
      return;
    }
    setValidationError(null);
    setEmailExistsFor(null);
    try {
      setIsLoading(true);
      const endpoint = isAuthenticated
        ? '/api/examregistration/UpdateMyRegistrations'
        : '/api/examregistration/Register';
      const response = await RestService.post<Api.ExamRegistrationRequest, Api.RegisterExamResponse>(endpoint, form);
      if (response.Success) {
        const snapshot: Api.ExamRegistrationRequest = JSON.parse(JSON.stringify(form));
        setSubmittedData(snapshot);
        setForm(emptyForm());
        setShowParent2(false);
      } else if (response.EmailAlreadyExists) {
        setEmailExistsFor(form.ParentEmail.trim());
        setValidationError(response.Message ?? t.somethingWrong);
      } else {
        setValidationError(response.Message ?? t.somethingWrong);
      }
    } catch (e) {
      toast.error(`${t.somethingWrong}: ${e}`);
    } finally {
      setIsLoading(false);
    }
  };

  if (submittedData) {
    const departmentName = (id?: number) => departments.find(d => d.Id === id)?.Name ?? '';
    return (
      <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center" style={{ maxWidth: '95rem' }}>
        <LanguageToggle language={language} setLanguage={setLanguage} t={t} />
        <div className="ods-grid__column--12 ods-grid__column--start-3-breakpoint-medium ods-grid__column--end-11-breakpoint-medium">
          <div className="ods-status-card">
            <div className="ods-status-card__content">
              <h3 className="ods-status-card__heading">{t.successHeading}</h3>
              <p>{t.successLead}</p>

              <h4 className="ods-margin-top-11">{t.summaryHeading}</h4>

              <p className="ods-margin-top-3"><strong>{t.summaryChildren}</strong></p>
              <table style={summaryTableStyle}>
                <thead>
                  <tr>
                    <th style={summaryThStyle}>{t.colFirstname}</th>
                    <th style={summaryThStyle}>{t.colLastname}</th>
                    <th style={summaryThStyle}>{t.colTamilName}</th>
                    <th style={summaryThStyle}>{t.colDob}</th>
                    <th style={summaryThStyle}>{t.department}</th>
                    <th style={summaryThStyle}>{t.className}</th>
                  </tr>
                </thead>
                <tbody>
                  {submittedData.Children.map((c, i) => (
                    <tr key={i}>
                      <td style={summaryTdStyle}>{c.Firstname}</td>
                      <td style={summaryTdStyle}>{c.Lastname}</td>
                      <td style={summaryTdStyle}>{[c.FirstnameTamil, c.LastnameTamil].filter(Boolean).join(' ')}</td>
                      <td style={summaryTdStyle}>{c.DateOfBirth}</td>
                      <td style={summaryTdStyle}>{departmentName(c.DepartmentId)}</td>
                      <td style={summaryTdStyle}>{c.ClassName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <p className="ods-margin-top-3"><strong>{t.summaryParents}</strong></p>
              <table style={summaryTableStyle}>
                <thead>
                  <tr>
                    <th style={summaryThStyle}>{t.colEmail}</th>
                    <th style={summaryThStyle}>{t.colMobile}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={summaryTdStyle}>{submittedData.ParentEmail}</td>
                    <td style={summaryTdStyle}>{submittedData.ParentMobile}</td>
                  </tr>
                  {submittedData.Parent2Email ? (
                    <tr>
                      <td style={summaryTdStyle}>{submittedData.Parent2Email}</td>
                      <td style={summaryTdStyle}>{submittedData.Parent2Mobile}</td>
                    </tr>
                  ) : null}
                </tbody>
              </table>

              <p className="ods-margin-top-11">{t.emailNotice}</p>

              <p className="ods-margin-top-11">
                {t.signoff}<br />
                {t.orgName}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoading && <OKomLoading text={t.loading} />}
      <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center" style={{ maxWidth: '95rem' }}>
        <LanguageToggle language={language} setLanguage={setLanguage} t={t} />

        <div className="ods-grid__column--12 ods-grid__column--start-1-breakpoint-medium ods-grid__column--end-5-breakpoint-medium">
          <div className="ods-status-card">
            <div className="ods-status-card__content">
              <h3 className="ods-status-card__heading">{t.practicalHeading}</h3>

              {EXAM_EVENTS.map((ev, i) => (
                <div key={i} style={{ marginTop: '0.5rem' }}><br />
                  <div>{ev.name[language]}</div>
                  <div><strong>{ev.date[language]}</strong></div>
                </div>
              ))}
<br />
              <p style={{ marginTop: '1rem' }}>
                <strong>{t.practicalContactLabel}:</strong><br />
                <a href={`mailto:${PRACTICAL_INFO.contactEmail}`} className="o-kom-link">{PRACTICAL_INFO.contactEmail}</a><br />
                <a href={`tel:${PRACTICAL_INFO.contactPhone.replace(/\s+/g, '')}`} className="o-kom-link">{PRACTICAL_INFO.contactPhone}</a>
              </p>
              <p style={{ marginTop: '0.5rem' }}>
                <strong>{t.practicalAddressLabel}:</strong><br />
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="o-kom-link">
                  {PRACTICAL_INFO.addressLines.map((line, i) => (
                    <React.Fragment key={i}>{line}{i < PRACTICAL_INFO.addressLines.length - 1 && <br />}</React.Fragment>
                  ))}
                  <span className="ods-icon ods-icon--new-window" aria-hidden="true" style={{ marginLeft: '0.25rem' }}></span>
                </a>
              </p>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block' }}>
                <img
                  src="/assets/groruddalen_skole.jpg"
                  alt={PRACTICAL_INFO.addressLines[0]}
                  style={{ width: '100%', maxWidth: 240, height: 'auto', borderRadius: 4, border: '1px solid #ccc' }}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="ods-grid__column--12 ods-grid__column--start-5-breakpoint-medium ods-grid__column--end-9-breakpoint-medium">
          {form.Children.map((child, index) => (
            <div key={index} className={index === 0 ? 'ods-status-card' : 'ods-status-card ods-margin-top-3'}>
              <div className="ods-status-card__content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h3 className="ods-status-card__heading">{t.childHeading(index + 1, form.Children.length)}</h3>
                  {index > 0 && (
                    <button type="button" onClick={() => removeChild(index)} aria-label={t.removeChildAria(index + 1)} style={removeButtonStyle}>×</button>
                  )}
                </div>

                <label className="ods-input__label">{t.firstname}
                  <input value={child.Firstname} onChange={e => updateChild(index, 'Firstname', e.target.value)} onBlur={() => translateNameField(index, 'Firstname', 'FirstnameTamil')} className="ods-input__input" type="text" autoComplete="off" data-openreplay-obscured="" />
                </label>

                <label className="ods-input__label">{t.lastname}
                  <input value={child.Lastname} onChange={e => updateChild(index, 'Lastname', e.target.value)} onBlur={() => translateNameField(index, 'Lastname', 'LastnameTamil')} className="ods-input__input" type="text" autoComplete="off" data-openreplay-obscured="" />
                </label>

                <label className="ods-input__label ods-margin-top-11">{t.firstnameTamil}
                  <input value={child.FirstnameTamil ?? ''} onChange={e => updateChild(index, 'FirstnameTamil', e.target.value)} className="ods-input__input" type="text" data-openreplay-obscured="" />
                </label>

                <label className="ods-input__label">{t.lastnameTamil}
                  <input value={child.LastnameTamil ?? ''} onChange={e => updateChild(index, 'LastnameTamil', e.target.value)} className="ods-input__input" type="text" data-openreplay-obscured="" />
                </label>

                <label className="ods-input__label ods-margin-top-11">{t.dateOfBirth}
                  <input value={child.DateOfBirth ?? ''} onChange={e => updateChild(index, 'DateOfBirth', e.target.value)} className="ods-input__input" type="text" placeholder="dd.mm.yyyy" data-openreplay-obscured="" />
                </label>

                <label className="ods-input__label">{t.department}
                  <select value={child.DepartmentId} onChange={e => updateChild(index, 'DepartmentId', parseInt(e.target.value, 10))} className="ods-input__input">
                    <option value={0}>{t.selectDepartment}</option>
                    {departments.filter(d => ALLOWED_DEPARTMENT_IDS.has(d.Id)).map(d => (<option key={d.Id} value={d.Id}>{d.Name}</option>))}
                  </select>
                </label>

                <label className="ods-input__label">{t.className}
                  <select value={child.ClassName} onChange={e => updateChild(index, 'ClassName', e.target.value)} className="ods-input__input">
                    <option value="">{t.selectClass}</option>
                    {classOptions.map(c => (<option key={c.value} value={c.value}>{c.label}</option>))}
                  </select>
                </label>
              </div>
            </div>
          ))}

          {form.Children.length < MAX_CHILDREN && (
            <button type="button" onClick={addChild} className="ods-button ods-button--yellow ods-button--fullwidth ods-margin-top-3">{t.addChild}</button>
          )}
        </div>

        <div className="ods-grid__column--12 ods-grid__column--start-9-breakpoint-medium ods-grid__column--end-13-breakpoint-medium">
          <div className="ods-status-card">
            <div className="ods-status-card__content">
              <h3 className="ods-status-card__heading">{t.parentHeading}</h3>

              <label className="ods-input__label">{t.parentEmail}
                <input value={form.ParentEmail} onChange={e => updateParent('ParentEmail', e.target.value)} className="ods-input__input" type="email" autoComplete="email" />
              </label>

              <label className="ods-input__label">{t.parentMobile}
                <input value={form.ParentMobile ?? ''} onChange={e => updateParent('ParentMobile', e.target.value)} className="ods-input__input" type="tel" autoComplete="tel" />
              </label>
            </div>
          </div>

          {showParent2 ? (
            <div className="ods-status-card ods-margin-top-3">
              <div className="ods-status-card__content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h3 className="ods-status-card__heading">{t.parent2Heading}</h3>
                  <button type="button" onClick={removeParent2} aria-label={t.removeParent2Aria} style={removeButtonStyle}>×</button>
                </div>

                <label className="ods-input__label">{t.parentEmail}
                  <input value={form.Parent2Email ?? ''} onChange={e => updateParent('Parent2Email', e.target.value)} className="ods-input__input" type="email" autoComplete="off" />
                </label>

                <label className="ods-input__label">{t.parentMobile}
                  <input value={form.Parent2Mobile ?? ''} onChange={e => updateParent('Parent2Mobile', e.target.value)} className="ods-input__input" type="tel" autoComplete="off" />
                </label>
              </div>
            </div>
          ) : (
            <button type="button" onClick={addParent2} className="ods-button ods-button--yellow ods-button--fullwidth ods-margin-top-3">{t.addParent}</button>
          )}
        </div>

        <div className="ods-grid__column--12 ods-grid__column--start-4-breakpoint-medium ods-grid__column--end-10-breakpoint-medium ods-margin-top-11">
          {validationError && (
            <div className="ods-margin-bottom-3">
              <PktAlert title={t.validationTitle} skin="warning" compact>
                <span>{validationError}</span>
                {emailExistsFor && (
                  <>
                    {' '}
                    <a href="/login" className="o-kom-link">{t.loginLink}</a>
                  </>
                )}
              </PktAlert>
            </div>
          )}
          <div className="ods-text--align-center ods-margin-bottom-3">
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className="o-kom-link">
              {t.privacyLink}
              <span className="ods-icon ods-icon--new-window" aria-hidden="true" style={{ marginLeft: '0.25rem' }}></span>
            </a>
          </div>
          <button disabled={isLoading} className="ods-button ods-button--fullwidth" onClick={handleSubmit}>{t.send}</button>
        </div>

      </div>
    </>
  );
};

export default withRouter(ExamRegistrationView);
